export default "__VITE_ASSET__6387f6bd__"